"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIRST_PARTY_THEMES = void 0;
exports.getFirstPartyTheme = getFirstPartyTheme;
const atelier_1 = require("./atelier");
const bloom_1 = require("./bloom");
const kirana_pop_1 = require("./kirana-pop");
const neon_grid_1 = require("./neon-grid");
const nordic_calm_1 = require("./nordic-calm");
const studio_folio_1 = require("./studio-folio");
/** Dunea's own themes, free, available to every app without an install. */
exports.FIRST_PARTY_THEMES = [
    atelier_1.ATELIER_THEME,
    kirana_pop_1.KIRANA_POP_THEME,
    nordic_calm_1.NORDIC_CALM_THEME,
    neon_grid_1.NEON_GRID_THEME,
    bloom_1.BLOOM_THEME,
    studio_folio_1.STUDIO_FOLIO_THEME,
];
function getFirstPartyTheme(id) {
    return exports.FIRST_PARTY_THEMES.find((t) => t.id === id);
}
